import { render, staticRenderFns } from "./AdminKits.vue?vue&type=template&id=5b90842e&scoped=true&"
import script from "./AdminKits.vue?vue&type=script&lang=js&"
export * from "./AdminKits.vue?vue&type=script&lang=js&"
import style0 from "./AdminKits.vue?vue&type=style&index=0&id=5b90842e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b90842e",
  null
  
)

export default component.exports